import { DeviceType } from './device-type';
import { keyBy as _keyBy, NumericDictionary } from 'lodash';


// TODO: Update the images. Upload new ones and match up Jeannine's list to the proper imageKey value
export const deviceTypes: readonly DeviceType[] = [
  {
    id: 0,
    code: "REFR",
    displayName: "Refrigerator",
    imageKey: "refrigerator-2tone",
  },
  {
    id: 1,
    code: "DRYE",
    displayName: "Dryers",
    imageKey: "dryer-2tone",
  },
  {
    id: 2,
    code: "WASH",
    displayName: "Washers",
    imageKey: "washer-2tone",
  },
  {
    id: 3,
    code: "WADR",
    displayName: "Washer and Dryer Combo",
    imageKey: "combo-2tone",
  },
  {
    id: 4,
    code: "RANG",
    displayName: "Ranges",
    imageKey: "ranges-2tone",
  },
  {
    id: 5,
    code: "COOK",
    displayName: "Cooktops",
    imageKey: "cooktop-2tone",
  },
  {
    id: 6,
    code: "WAOV",
    displayName: "Wall Ovens",
    imageKey: "wall-oven-2tone",
  },
  {
    id: 7,
    code: "DISH",
    displayName: "Dishwashers",
    imageKey: "dishwasher-2tone",
  },
  {
    id: 8,
    code: "MICR",
    displayName: "Microwaves",
    imageKey: "microwave-2tone",
  },
  {
    id: 9,
    code: "ROVA",
    displayName: "Robotic Vacuums",
    imageKey: "cleaner-2tone",
  },
  {
    id: 10,
    code: "SMAP",
    displayName: "Small Appliances",
    imageKey: "small-appliance-2tone",
  },
  {
    id: 11,
    code: "CAME",
    displayName: "Camera",
    imageKey: "camera-2tone",
  },
  {
    id: 12,
    code: "CAMC",
    displayName: "Camcorders",
    imageKey: "camcorder-2tone",
  },
  {
    id: 13,
    code: "DRON",
    displayName: "Drones",
    imageKey: "drone-2tone",
  },
  {
    id: 14,
    code: "CSRE",
    displayName: "Car Stereo Receivers",
    imageKey: "car-stereo-receiver-2tone",
  },
  {
    id: 15,
    code: "GPNA",
    displayName: "GPS Navigation",
    imageKey: "gps-navigation-2tone",
  },
  {
    id: 16,
    code: "CASE",
    displayName: "Car Security",
    imageKey: "car-security-2tone",
  },
  {
    id: 17,
    code: "BUDC",
    displayName: "Back-Up & Dash Cameras",
    imageKey: "back-up-dash-camera-2tone",
  },
  {
    id: 18,
    code: "CVMP",
    displayName: "Car Video & Media Players",
    imageKey: "car-video-media-player-2tone",
  },
  {
    id: 19,
    code: "LAPT",
    displayName: "Laptop",
    imageKey: "laptop-2tone",
  },
  {
    id: 20,
    code: "DESK",
    displayName: "Desktop",
    imageKey: "desktop-2tone",
  },
  {
    id: 21,
    code: "MONI",
    displayName: "Monitors",
    imageKey: "monitor-2tone",
  },
  {
    id: 22,
    code: "STOR",
    displayName: "Storage",
    imageKey: "storage-2tone",
  },
  {
    id: 23,
    code: "COAC",
    displayName: "Computer Accessories",
    imageKey: "computer-accessories-2tone",
  },
  {
    id: 24,
    code: "EXEQ",
    displayName: "Exercise Equipment",
    imageKey: "exercise-equipment-2tone",
  },
  {
    id: 25,
    code: "SMSC",
    displayName: "Smart Scale",
    imageKey: "smart-scale-2tone",
  },
  {
    id: 26,
    code: "HTSY",
    displayName: "Home Theater System",
    imageKey: "home-theater-system-2tone",
  },
  {
    id: 27,
    code: "SOUN",
    displayName: "Soundbars",
    imageKey: "sound-system-2tone",
  },
  {
    id: 28,
    code: "BRPL",
    displayName: "Blu-ray Players",
    imageKey: "bluray-player-2tone",
  },
  {
    id: 29,
    code: "PROJ",
    displayName: "Projectors",
    imageKey: "projector-2tone",
  },
  {
    id: 30,
    code: "SMPL",
    displayName: "Streaming Media Players",
    imageKey: "streaming-2tone",
  },
  {
    id: 31,
    code: "SMPH",
    displayName: "Smartphone",
    imageKey: "smartphones-2tone",
  },
  {
    id: 32,
    code: "PRIN",
    displayName: "Printers",
    imageKey: "printer-2tone",
  },
  {
    id: 33,
    code: "BLSP",
    displayName: "Bluetooth Speakers",
    imageKey: "bluetooth-speakers-2tone",
  },
  {
    id: 34,
    code: "SMSP",
    displayName: "Smart Speakers",
    imageKey: "smart-speakers-2tone",
  },
  {
    id: 35,
    code: "SMDI",
    displayName: "Smart Displays",
    imageKey: "smart-display-2tone",
  },
  {
    id: 36,
    code: "SMLI",
    displayName: "Smart Lighting",
    imageKey: "light-2tone",
  },
  {
    id: 37,
    code: "SPOU",
    displayName: "Smart Plugs & Outlets",
    imageKey: "smart-plug-2tone",
  },
  {
    id: 38,
    code: "SMFA",
    displayName: "Smart Fans",
    imageKey: "smart-fan-2tone",
  },
  {
    id: 39,
    code: "SMSW",
    displayName: "Smart Switches",
    imageKey: "light-switch-2tone",
  },
  {
    id: 40,
    code: "SMTH",
    displayName: "Smart Thermostats",
    imageKey: "thermostat-2tone",
  },
  {
    id: 41,
    code: "SSPR",
    displayName: "Smart Sprinkler",
    imageKey: "smart-sprinkler-2tone",
  },
  {
    id: 42,
    code: "HOSE",
    displayName: "Home Security",
    imageKey: "home-security-2tone",
  },
  {
    id: 43,
    code: "BLTR",
    displayName: "Bluetooth Trackers",
    imageKey: "bluetooth-trackers-2tone",
  },
  {
    id: 44,
    code: "TABL",
    displayName: "Tablets",
    imageKey: "tablet-2tone",
  },
  {
    id: 45,
    code: "SMTV",
    displayName: "Smart TV",
    imageKey: "smart-tv-2tone",
  },
  {
    id: 46,
    code: "CONS",
    displayName: "Console",
    imageKey: "console-2tone",
  },
  {
    id: 47,
    code: "VGAC",
    displayName: "Video Game Accessories",
    imageKey: "game-accessories-2tone",
  },
  {
    id: 48,
    code: "SMAR",
    displayName: "Smartwatches",
    imageKey: "watch-2tone",
  },
  {
    id: 49,
    code: "VIRE",
    displayName: "Virtual Reality",
    imageKey: "vr-headset-2tone",
  },
  {
    id: 50,
    code: "HEMO",
    displayName: "Heartrate Monitor",
    imageKey: "fitness-tracker-2tone",
  },
  {
    id: 51,
    code: "SMRI",
    displayName: "Smart Ring",
    imageKey: "doorbell-2tone",
  },
  {
    id: 52,
    code: "SUNG",
    displayName: "Sunglasses",
    imageKey: "sunglasses-2tone",
  },
  {
    id: 53,
    code: "HEAD",
    displayName: "Headphones",
    imageKey: "headphones-2tone",
  },
  {
    id: 54,
    code: "ROUT",
    displayName: "Routers",
    imageKey: "wifi-2tone",
  },
  {
    id: 55,
    code: "MOGA",
    displayName: "Modems & Gateways",
    imageKey: "modem-gateway-2tone",
  },
  {
    id: 56,
    code: "NEEX",
    displayName: "Network Extenders",
    imageKey: "extender-2tone",
  },
  {
    id: 57,
    code: "UWFA",
    displayName: "USB Wi-Fi Adapters",
    imageKey: "adaptor-2tone",
  },
  {
    id: 58,
    code: "HOTS",
    displayName: "Hotspot",
    imageKey: "hotspot-2tone",
  },
  {
    id: 59,
    code: "FREZ",
    displayName: "Freezer",
    imageKey: "freezer-2tone",
  },
  {
    id: 60,
    code: "RAHD",
    displayName: "Range Hood",
    imageKey: "range-hood-2tone",
  },
  {
    id: 61,
    code: "ORMW",
    displayName: "Over the Range Microwave",
    imageKey: "over-range-microwave-2tone",
  },
];

export const deviceTypesByCodeDictionary = _keyBy(deviceTypes, 'code');
export const deviceTypesByIdDictionary: NumericDictionary<DeviceType> = _keyBy(deviceTypes, 'id');
